import request from '@/utils/httpRequest'

//获取轮播图列表
export function getBannerList(obj) {
  return request({
    url: '/api/bsd/common/bannerList',
    method: 'post',
    data: obj,
  })
}

//获取地图板块列表
export function getMapList(obj) {
  return request({
    url: '/api/bsd/common/mapList',
    method: 'post',
    data: obj,
  })
}

//获取通知公告列表
export function getNoticeList(obj) {
  return request({
    url: '/api/bsd/notice/list',
    method: 'post',
    data: obj,
  })
}

//获取通知公告明细
export function getNoticeDetail(obj) {
  return request({
    url: '/api/bsd/notice/getDetail',
    method: 'post',
    data: obj,
  })
}

//获取当前用户的未读公告数
export function getNoticeNewNum(obj) {
  return request({
    url: '/api/bsd/notice/getNewNum',
    method: 'post',
    data: obj,
  })
}

//获取岗位列表
export function getPostList(obj) {
  return request({
    url: '/api/bsd/common/postList',
    method: 'post',
    data: obj,
  })
}

//主机厂/经销商-护照等级
export function getBsdUserNum(obj) {
  return request({
    url: '/api/lp/common/getBsdUserNum',
    method: 'post',
    data: obj,
  })
}

//经销商学分排名
export function getDealerIntegral(obj, page, size) {
  return request({
    url: `/api/lp/common/dealerIntegral?pageNum=${page}&pageSize=${size}`,
    method: 'post',
    data: obj,
  })
}

//学员学分排名
export function getXyIntegral(obj, page, size) {
  return request({
    url: `/api/lp/common/xyIntegral?pageNum=${page}&pageSize=${size}`,
    method: 'post',
    data: obj,
  })
}

//添加意见
export function addOpinion(obj) {
  return request({
    url: '/api/bsd/common/addOpinion',
    method: 'post',
    data: obj,
  })
}

//板块课程学习情况
export function getMapCourse(obj, page, size) {
  return request({
    url: `/api/lp/common/mapCourse?pageNum=${page}&pageSize=${size}`,
    method: 'post',
    data: obj,
  })
}

export function getMapCourseAll(obj, page, size) {
  return request({
    url: `/api/lp/common/myCourse?pageNum=${page}&pageSize=${size}`,
    method: 'post',
    data: obj,
  })
}

//月度统计
export function getMonthStudy(obj) {
  return request({
    url: '/api/lp/month/monthStudy',
    method: 'post',
    data: obj,
  })
}

//月度明细
export function getMonthDetail(obj) {
  return request({
    url: '/api/lp/month/monthStudyDetail',
    method: 'post',
    data: obj,
  })
}

//月度明细
export function getMonthStudyXY(obj) {
  return request({
    url: '/api/lp/month/monthStudyXy',
    method: 'post',
    data: obj,
  })
}

//我的课程
export function getMyCourse(obj, page, size) {
  return request({
    url: `/api/lp/common/myCourse?pageNum=${page}&pageSize=${size}`,
    method: 'post',
    data: obj,
  })
}

//获取经销商详情
export function getDealerDetail(obj) {
  return request({
    url: '/api/bsd/common/dealerDetail',
    method: 'post',
    data: obj,
  })
}

export function uploadFile(obj) {
  return request({
    url: '/api/common/upload',
    method: 'post',
    data: obj,
    // headers: {
    //   'Content-Type': 'multipart/form-data;',
    // },
  })
}
